module.exports = __webpack_public_path__ + "img/prop-praline-1.13f9d91e.webp";